import { takeEvery, put, select } from 'redux-saga/effects'

import {
  activityActions,
  sendOnboardingEveningNotification,
  subscribeToProTrack,
  updateSubscribeToProTrack,
} from 'store/entities/identity/actions'
// @ts-ignore
import { showSuccess } from 'store/entities/toastr/utils'
import { SUBSCRIBED_TO_PROTRACK } from 'app/constants/toastrMessages'
import { modal } from 'store/entities/modal/actions'
import OnboardingBriefQuiz from 'app/domains/routes/OnBoarding/OnBoardingBriefQuiz'
import { getIdentityFirstLogin, isUserEverTakeProTrack } from 'store/entities/identity/selectors'
import { IHandleProTrackSubscriptionPostSuccess } from 'store/entities/identity/sagas/interfaces'
import { push } from 'connected-react-router'

export default function* proTrackSubscriptionSaga() {
  // @ts-ignore
  yield takeEvery(subscribeToProTrack.success.toString(), handleProTrackSubscriptionPostSuccess)
  // @ts-ignore
  yield takeEvery(updateSubscribeToProTrack.success.toString(), handleProTrackSubscriptionPostSuccess)
}

export function* handleProTrackSubscriptionPostSuccess({ payload: { data } }: IHandleProTrackSubscriptionPostSuccess) {
  const {
    organization: { isPreTrackSurveyEnabled },
    proTrack: { proTrackName, name },
    activity: { id: activityId, userActivityId },
    progressDay,
    isSubscriptionFromEmail,
  } = data
  const isFirstLogin = yield select(getIdentityFirstLogin)
  const isUserEverTookProTrack = yield select(isUserEverTakeProTrack)
  showSuccess({ content: SUBSCRIBED_TO_PROTRACK(`${proTrackName} (${name})`) })
  if (isSubscriptionFromEmail) {
    yield put(push('/dashboard'))
  }
  if (isFirstLogin) {
    // @ts-ignore
    yield activityActions.commit.call({ activityId, userActivityId })
    yield put(sendOnboardingEveningNotification())
  } else {
    if (progressDay === 1 && isSubscriptionFromEmail) {
      // @ts-ignore
      yield activityActions.commit.call({ activityId, userActivityId })
    } else if (!isUserEverTookProTrack) {
      // @ts-ignore
      yield activityActions.commit.call({ activityId, userActivityId })
    }

    if (isPreTrackSurveyEnabled) {
      yield put(modal.show(OnboardingBriefQuiz, { size: 'md', important: true }))
    }
  }
}
